import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

const getEmptyState = (isFetching = 0, reminders = []) => ({isFetching, reminders });
export const createDraft = (moduleId = null) => ({
    moduleId,
    number:     1,
    unit:       'hours',
    type:       'email',
    templateId: null,
    textBody:   null
});

export const sanitizeDraft = (draft) => ({
    ...draft,
    id:         Number(draft.id) || null,
    moduleId:   Number(draft.moduleId) || null,
    templateId: Number(draft.templateId) || null,
});

class ModuleReminderStore extends ReduceStore {

    getIndex(id) {
        return this._state.reminders.findIndex(r => r.id === id);
    }

    isFetching() {
        return this.getState().isFetching > 0;
    }

    getByModule(moduleId) {
        return this.getState().reminders.filter(r => r.moduleId === moduleId);
    }

    getInitialState() {
        return getEmptyState();
    }

    reduce(state, action) {
        let index, updates;
        switch (action.type) {
            case ActionTypes.MODULE_REMINDER_ADD_REQUEST:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching + 1 }});

            case ActionTypes.MODULE_REMINDER_ADD_SUCCESS:
                return update(this.getState(), {
                    isFetching: { $set: this._state.isFetching - 1 },
                    reminders: { $push: [sanitizeDraft(action.data)] }
                });

            case ActionTypes.MODULE_REMINDER_ADD_FAILURE:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching - 1 }});

            case ActionTypes.MODULE_REMINDER_LIST_REQUEST:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching + 1 }});

            case ActionTypes.MODULE_REMINDER_LIST_SUCCESS:
                return update(this.getState(), {
                    isFetching: { $set: this._state.isFetching - 1 },
                    reminders: { $set: action.data.map(sanitizeDraft) }
                });

            case ActionTypes.MODULE_REMINDER_LIST_FAILURE:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching - 1 }});

            case ActionTypes.MODULE_REMINDER_UPDATE_REQUEST:
                index = this.getIndex(action.payload.current.id);
                return update(this.getState(), {
                    isFetching: { $set: this._state.isFetching + 1 },
                    reminders: { [index]: { $set: action.payload.draft } }
                });

            case ActionTypes.MODULE_REMINDER_UPDATE_SUCCESS:
                index = this.getIndex(action.payload.current.id);
                return update(this.getState(), {
                    isFetching: { $set: this._state.isFetching - 1 },
                    reminders: { [index]: { $set: sanitizeDraft(action.data) } }
                });

            case ActionTypes.MODULE_REMINDER_UPDATE_FAILURE:
                index = this.getIndex(action.payload.current.id);
                return update(this.getState(), {
                    isFetching: { $set: this._state.isFetching - 1 },
                    reminders: { [index]: { $set: action.payload.current } }
                });

            case ActionTypes.MODULE_REMINDER_DELETE_REQUEST:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching + 1 }});

            case ActionTypes.MODULE_REMINDER_DELETE_SUCCESS:
                updates = { isFetching: { $set: this._state.isFetching - 1 } };
                index = this.getIndex(action.payload.current.id);
                if (-1 < index) {
                    updates.reminders = { $splice: [ [index, 1] ] };
                }
                return update(this.getState(), updates);

            case ActionTypes.MODULE_REMINDER_DELETE_FAILURE:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching - 1 }});

            case ActionTypes.MODULE_REMINDER_DELETE_ALL_REQUEST:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching + 1 }});

            case ActionTypes.MODULE_REMINDER_DELETE_ALL_SUCCESS:
                const reminders = this.getState().reminders.filter(r => r.moduleId !== action.payload.moduleId);
                return getEmptyState(0, reminders);

            case ActionTypes.MODULE_REMINDER_DELETE_ALL_FAILURE:
                return update(this.getState(), { isFetching: { $set: this._state.isFetching - 1 }});

            default:
                return state;
        }
    }
}

export default new ModuleReminderStore(CentricDispatcher);
